import { Button } from "@fluentui/react-northstar";
import React from "react";

import { usePaymentRedirect } from "../../../../_shared/actions/usePaymentRedirect";
import { useUserInfo } from "../../../../_shared/actions/useUserInfo";
import { clientEventTracker } from "../../../../_shared/utils/clientTelemetry";

export const PlanUpgradeButton: React.FC<{
  dataTName: string;
  isTrial?: boolean;
  label?: React.ReactNode;
  trackingSource: string;
}> = ({ dataTName, isTrial, label, trackingSource }) => {
  const { openPaymentPage } = usePaymentRedirect();
  const { user } = useUserInfo();
  return (
    <Button
      primary
      fluid
      content={label || "Upgrade"}
      data-tname={dataTName}
      onClick={() => {
        clientEventTracker.track("UpgradeButton clicked", user, {
          trackingSource,
        });
        openPaymentPage(trackingSource, isTrial);
      }}
    />
  );
};
